// extracted by mini-css-extract-plugin
module.exports = {"container":"today-details_container__h4NLw","temperature":"today-details_temperature__GGkKy"};